import {
    setVaultElement,
    setVaultElementQuantity,
    unsetVaultElement,
    VaultElementType
} from "./vaultElementSlice";
import {canHaveMultipleLids, getLidSizes, LidSize} from "../../containers/domain/lid";

type Thunk = (dispatch: any, getState: () => any) => void;

function groupLidSizes(lidSizes: LidSize[]): LidSize[][] {
    const map = new Map<number, LidSize[]>();

    for (const l of lidSizes) {
        const length = Math.max(l.width, l.length);

        if (!map.has(length)) map.set(length, []);
        map.get(length)?.push(l);
    }

    return Array.from(map.values());
}

export const updateVaultElements = (): Thunk => (dispatch, getState) => {
    dispatch(unsetVaultElement({elementType: 'any', id: 'any'}))
    const plan = getState().plan;

    if (!!plan.vault) {
        dispatch(setVaultElement({elementType: VaultElementType.Vault, id: null}))
    }
    if (plan.floor) {
        dispatch(setVaultElement({elementType: VaultElementType.Floor, id: null}))
    }
    if (plan.intermediateCeiling) {
        dispatch(setVaultElement({elementType: VaultElementType.IntermediateCeiling, id: null}))
    }
    if (plan.lid) {
        if (canHaveMultipleLids(plan) && plan.lid.manholes.length > 0) {
            const sizes = getLidSizes(plan);
            const groupedSizes = groupLidSizes(sizes);

            for (const group of groupedSizes) {
                const size = group[0];
                const id = size.manholeIds[0];

                dispatch(setVaultElement({elementType: VaultElementType.Lid, id}))
                if (group.length > 1) {
                    dispatch(setVaultElementQuantity({elementType: VaultElementType.Lid, id, quantity: group.length}))
                }
            }
        } else {
            dispatch(setVaultElement({elementType: VaultElementType.Lid, id: null}))
        }
    }
}
